export interface NotificationsState {
  status: string | null
  data: object
  loginViewNotification: LoginViewNotification | {}
  internalMessages: InternalMessage[]
  contextInternalMessages: any[]
}

export interface InternalMessage {
  id: number
  title: string
  content: string
  createdAt: string
}

export interface LoginViewNotification {
  type: string
  text: string
}

export const notificationsMutationTypes = {
  FETCH_LOGIN_VIEW_NOTIFICATION: 'FETCH_LOGIN_VIEW_NOTIFICATION',
  FETCH_INTERNAL_MESSAGES: 'FETCH_INTERNAL_MESSAGES',
  FETCH_CONTEXT_INTERNAL_MESSAGES: 'FETCH_CONTEXT_INTERNAL_MESSAGES'
}
